import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { AvailableLanguages } from "@/shared/hooks/useTranslationLoader";

const getInitialLanguage = (): AvailableLanguages => {
  if (typeof window !== "undefined") {
    return (localStorage.getItem("locale") as AvailableLanguages) || "uz";
  }
  return "uz";
};

i18n.use(initReactI18next).init({
  fallbackLng: getInitialLanguage(),
  debug: true,
  interpolation: {
    escapeValue: false,
  },
  resources: {},
});

export default i18n;
